export default __webpack_public_path__ + "static/media/gallery - golpalott_01.2423a51e.jpg";